import { Subject } from 'rxjs';

const subject = new Subject();
const subjectClose = new Subject();

export const menuUserService = {
    emitReload: val => subject.next(val),
    reload: () => subject.asObservable()
};

export const menuUserCloseService = {
    emitReload: val => subjectClose.next(val),
    reload: () => subjectClose.asObservable()
};